import styled from 'styled-components';
import { InfoOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';

import { Text18 } from '../../ui/Text18';
import { Text22 } from '../../ui/Text22';

export const CardContent = styled.div`
  padding: 32px;
`;

export const ExpandWrapper = styled.div`
  display: flex;
  align-ites: center;
  margin-top: 24px;
  cursor: pointer;
  gap: 10px;
  @media (max-width: 1035px) {
    justify-content: center;
  }
`;

export const Expand = styled.div<{ expand: boolean }>`
  color: ${({ theme }) => theme.colors.accentBlue};
  transform: ${props => props.expand ? 'rotate(90deg)' : 'rotate(0deg)'};
`;

export const Wrapper = styled.div<{ expand: boolean }>`
  background-color: ${({ theme }) => theme.colors.lightGray};
  height: ${props => props.expand ? '545px' : '168px'};
  border-radius: 8px;
  margin-bottom: 8px;
  transition: 0.6s;
  overflow: hidden;
  @media (max-width: 1035px) {
    height: ${props => props.expand ? '1300px' : '420px'};
  }
`;

export const ExpandText = styled(Text18)`
  color: ${({ theme }) => theme.colors.accentBlue};
`;

export const BtsWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  gap: 50px;

  @media (max-width: 1035px) {
    flex-direction: column;
  }
`;

export const ButtonsWrapper = styled.div`
  flex: 1;
  display: flex;
  gap: 16px;

  @media (max-width: 1035px) {
    flex-direction: column;
  }
`;

export const AssistanceWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const AsistanceTitle = styled.h4`
  color: ${({ theme }) => theme.colors.descriptionColor};
  font-weight: 500;
`;

export const AsistanceValue = styled.h4`
  color: ${({ theme }) => theme.colors.stepActiveColor};
  font-weight: 500;
`;

export const Info = styled(InfoOutlined)`
  color: ${({ theme }) => theme.colors.accentBlue};
  cursor: pointer;
  widht: 16px;
  height: 16px;
`;

export const CardWrapper = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 1035px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const CardHeaderItem = styled.div`
  flex: 1;
`;

export const CardHeaderLogo = styled.img`
  height: 71px;
  transition: 0.2s;
`;

export const InsuranceSumWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const InsuranceSum = styled(Text22)`
  font-size: 32px;
  display: flex;
  gap: 10px;
`;

export const InsuranceSumOptions = styled(Text18)`
  color: ${({ theme }) => theme.colors.darkGray};
  margin-top: 3px;
  font-size: 24px;
  font-weight: 500;
`;

export const CardInfo = styled(InfoOutlined)`
  color: ${({ theme }) => theme.colors.accentBlue};
  cursor: pointer;
  widht: 16px;
  height: 16px;
`;

export const ButtonWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;

export const BuyButton = styled(Button)`
  width: 260px;
  height: 50px;
  align-self: flex-end;
  justify-content: center;
`;
